export default __webpack_public_path__ + "static/media/note.bff9dcb9.png";